let today = new Date();
// today = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 4);
let days_total = Math.floor(
    new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0
    ).getTime() /
    (1000 * 60 * 60 * 24)
);
let date = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + ((11 - today.getDay()) % 7) + 1,
    0,
    0,
    0
);

const WEEK = 604800000;
const DAY = 86400000;
let next = new Date(2020, 11, 27, 19, 0, 0)

// if (today > next && today < next2) {
//     next = next2;
// } else {
//     next = new Date(2020, 11, 5, 22, 0, 0);

//     while (today.valueOf() - next.valueOf() > 0) {
//         console.log("tick");
//         next = new Date(next.valueOf() + 3 * DAY);
//     }
// }

const PHONE = "+7 495 785 27 27"
    .replace(/\s/g, "\u00A0")
    .replace(/-/g, "\u2011");
const PHONE_RAW = PHONE.replace(/\D+/g, "");

export default {
    offices: [{
        address: "г. Москва, Ленинградское шоссе, 63Б",
        y: 55.863904,
        x: 37.46335,
    }, ],
    phone: PHONE,
    phone_raw: PHONE_RAW,
    worktime: "с 8:00 до 22:00",
    coords: {
        x_center: 37.46335,
        y_center: 55.863904,
    },
    salon_name: "Audi",
    teh_name: "Audi",
    need_agreement: true,
    cKeeper: undefined,
    end_date: new Date(2021, 8, 18)
};